import styled from 'styled-components';

export const DropZone = styled.div<{ isDragActive: boolean }>`
    border: 2px dashed ${({ isDragActive }) => (isDragActive ? 'var(--primary)' : '#d1d5db')};
    border-radius: 8px;
    padding: 48px 24px;
    text-align: center;
    background-color: ${({ isDragActive }) => (isDragActive ? '#f0f9ff' : '#fafafa')};
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;

    &:hover {
        border-color: var(--primary);
        background-color: #f9fafb;
    }
`;

export const UploadIcon = styled.div`
    color: var(--primary);
    font-size: 48px;
    margin-bottom: 8px;
`;

export const DropZoneText = styled.p`
    font-size: 16px;
    color: #374151;
    font-weight: 500;
    margin: 0;
`;

export const DropZoneSubtext = styled.p`
    font-size: 14px;
    color: #6b7280;
    margin: 4px 0 0 0;
`;

export const SelectedFile = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    background-color: #f3f4f6;
    border-radius: 6px;
    margin-top: 16px;
`;

export const FileInfo = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const FileName = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: #111827;
`;

export const FileSize = styled.span`
    font-size: 12px;
    color: #6b7280;
`;

export const RemoveButton = styled.button`
    background: none;
    border: none;
    color: #ef4444;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background-color 0.2s;

    &:hover {
        background-color: #fee2e2;
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 24px;
`;

export const ErrorMessage = styled.div`
    color: #dc2626;
    font-size: 14px;
    padding: 12px;
    background-color: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 6px;
    margin-top: 16px;
`;

export const ModalHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ModalTitle = styled.h2`
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: #111827;
`;

export const ModalDescription = styled.p`
    margin: 0;
    font-size: 0.875rem;
    color: #6b7280;
`;

export const ProgressContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;
    padding: 16px;
    background-color: #f9fafb;
    border-radius: 6px;
    border: 1px solid #e5e7eb;
`;

export const LoadingText = styled.p`
    font-size: 14px;
    color: #374151;
    font-weight: 500;
    margin: 0;
`;

export const SecretMappingContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 16px;
`;

export const SecretMappingItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SecretLabel = styled.label`
    font-size: 14px;
    font-weight: 500;
    color: #111827;
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const RequiredBadge = styled.span`
    font-size: 10px;
    color: #dc2626;
    font-weight: 600;
`;

export const SecretDescription = styled.p`
    font-size: 13px;
    color: #6b7280;
    margin: 0 0 8px 0;
`;

export const InfoMessage = styled.div`
    color: #0369a1;
    font-size: 14px;
    padding: 12px;
    background-color: #f0f9ff;
    border: 1px solid #bae6fd;
    border-radius: 6px;
    margin-bottom: 16px;
`;

export const HiddenFileInput = styled.input`
    display: none;
`;
